<template>
    <div class="content">
        <div class="card-box-tree">
            <CustomTree ref="CustomTree" editable @change="handelTree" />
        </div>
        <div class="card-box-content">
            <CustomForm v-loading="loading" @change="changeForm" :data="data" style="margin-left: 20px;" />
        </div>
    </div>
</template>
<script>
import CustomTree from "@/components/custom/CustomTree"
import CustomForm from "@/components/custom/CustomForm"
export default {
    components: { CustomTree, CustomForm },
    data() {
        return {
            data: [],
            loading: false,
        }
    },
    created() {
    },
    methods: {
        changeForm(data) {
            if (!data) return
            this.loading = true
            this.$https.post(this.$api.ContentManagement.updateMgrcat + data.id, data).then(() => {
                this.$message.success("更新成功")
                this.$refs.CustomTree.initTree()
                this.loading = false
            })
        },
        // article， picture introduction
        handelTree(data) {
            if (!data) {
                this.data = []
                return
            }
            let headerData = [
                { label: "pid", prop: "pid", type: "parent", value: "tree", span: 24, hidden: true },
                { label: "栏目名称", prop: "name", type: "input", value: "", required: true, span: 24 },
                { label: "栏目ID", prop: "id", type: "input", value: "", required: true, span: 24, disabled: true, },
                { label: "展示类型", prop: "areaCode", type: "select", opt: [{ label: '横幅', value: 'banner' }, { label: '横排', value: 'horizontal' }, { label: '竖排', value: 'vertical' }], value: "", span: 24, },
                { label: "图片栏目", prop: "imgChannel", type: "switch", value: true, span: 12 },
                { label: "允许投稿", prop: "memberPost", type: "switch", value: true, span: 12 },
                { label: "栏目统计", prop: "stat", type: "switch", value: false, span: 12 },
                { label: "首页展示", prop: "preview", type: "switch", value: true, span: 12 },
                { label: "状态", prop: "status", value: "", type: "select", opt: [{ label: "启用", value: "active" }, { label: "禁用", value: "inactive" }], span: 24 },
            ]
            this.data = headerData.map(el => {
                return Object.assign(el, { value: data[el.prop] })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    width: 100%;
    overflow: hidden;

    .card-box-tree {
        float: left;
        width: 320px;
    }

    .card-box-content {
        float: left;
        width: calc(100% - 320px);

        /deep/.el-button--default {
            display: none;
        }
    }
}
</style>